import { render } from "./caseDetails.vue?vue&type=template&id=69855379"
import script from "./caseDetails.vue?vue&type=script&lang=js"
export * from "./caseDetails.vue?vue&type=script&lang=js"

import "./caseDetails.vue?vue&type=style&index=0&id=69855379&lang=css"

import exportComponent from "D:\\code\\vifa官网\\vifa\\vifa-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__